export var TYPOGRAPHY_CLASS_PREFIX = 'Typography';